export default __webpack_public_path__ + "static/media/login-text-bg.4888348f.svg";